import { render } from "./EditIG.vue?vue&type=template&id=39b0197f&scoped=true"
import script from "./EditIG.vue?vue&type=script&lang=js"
export * from "./EditIG.vue?vue&type=script&lang=js"

import "./EditIG.vue?vue&type=style&index=0&id=39b0197f&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39b0197f"]])

export default __exports__